import { Button, Modal } from "react-bootstrap";
import React, { useState } from "react";
import { InfoIcon } from "../../../../components/ui/icons";
import DeviceUpdateReportExportCSV from "./DeviceUpdateReportExportCSV";
const organizationSummaryModal = ({ orgDetails, firmware }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow}>
        <InfoIcon />
      </a>
      <Modal
        show={show}
        onHide={handleClose}
        className="modal-container viewOrgDetails-modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="viewdetails-heading">
              <h1>Updates summary</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="viewOrgdetails-container">
            <div className="orgDetails">
              <label>No. of Devices Failed</label>
              <div className="info-icon-container">
              <span>
                {firmware
                  ? orgDetails.firmwareFailedCount
                  : orgDetails.iotFailedCount}
              </span>
              {
                  <DeviceUpdateReportExportCSV
                    orgId={orgDetails.orgId}
                    updateStatus="failed"
                    isFirmware={firmware}
                    deviceCount={firmware ? orgDetails.firmwareFailedCount : orgDetails.iotFailedCount}
                  />
                }
                </div>
            </div>
            <div className="orgDetails">
              <label>No. of Devices Success</label>
              <div className="info-icon-container">
              <span>
                {firmware
                  ? orgDetails.firmwareSuccessCount
                  : orgDetails.iotSuccessCount}
              </span>
              {
                  <DeviceUpdateReportExportCSV
                    orgId={orgDetails.orgId}
                    updateStatus="success"
                    isFirmware={firmware}
                    deviceCount={firmware ? orgDetails.firmwareSuccessCount : orgDetails.iotSuccessCount}
                  />
                }
              </div>
            </div>
            <div className="orgDetails">
              <label>No. of Devices Pending</label>
              <div className="info-icon-container">
                <span>
                  {firmware
                    ? orgDetails.firmwarePendingCount
                    : orgDetails.iotPendingCount}
                </span>
                {
                  <DeviceUpdateReportExportCSV
                    orgId={orgDetails.orgId}
                    updateStatus="pending"
                    isFirmware={firmware}
                    deviceCount={firmware ? orgDetails.firmwarePendingCount : orgDetails.iotPendingCount}
                  />
                }
              </div>
            </div>
             <div className="orgDetails">
              <label>No. of Devices mismatched</label>
              <div className="info-icon-container">
                <span>
                  {firmware
                    ? orgDetails.firmwareMismatchedCount
                    : orgDetails.iotMismatchedCount}
                </span>
                {
                  <DeviceUpdateReportExportCSV
                    orgId={orgDetails.orgId}
                    updateStatus="mismatched"
                    isFirmware={firmware}
                    deviceCount={firmware ? orgDetails.firmwareMismatchedCount : orgDetails.iotMismatchedCount}
                  />
                }
              </div>
            </div>
            <div className="orgDetails">
              <label>Total No. of Devices</label>
              <div className="info-icon-container">
              <span>
                {firmware
                  ? orgDetails.totalFirmwareDevices
                  : orgDetails.totalIotDevices} 
              </span>
               {
                  <DeviceUpdateReportExportCSV
                    orgId={orgDetails.orgId}
                    updateStatus="all"
                    isFirmware={firmware}
                    deviceCount={firmware ? orgDetails.totalFirmwareDevices : orgDetails.totalIotDevices}
                  />
                }
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default organizationSummaryModal;
